/**
 * GlitchReplay project — single source of truth.
 *
 * The project id + public key were previously copy-pasted into six files:
 * the client SDK init (instrumentation-client.ts), the edge reporter
 * (lib/glitchreplay-edge.ts), two client error reporters
 * (lib/reportToolError.ts, components/GlobalErrorHandler.tsx), the tool
 * error boundary (app/tools/error.tsx), and the sourcemap upload step
 * (package.json). Centralising here keeps every surface in sync and lets
 * a deployment override the project via NEXT_PUBLIC_GLITCHREPLAY_DSN
 * without touching code. The default below is inventivehq.com's own
 * GlitchReplay project.
 *
 * DSN format (Sentry-style): https://<publicKey>@<host>/<projectId>
 */

const DEFAULT_DSN =
  "https://68d35775144d81bbfd18a2295510bbf1@glitchreplay.com/prj_e4f7e866340602d9a014";

const DSN_RE = /^https:\/\/([^@]+)@([^/]+)\/(.+)$/;

// A malformed override must never break error reporting — fall back to the
// default so the parsed parts below are always valid.
const rawDsn = process.env.NEXT_PUBLIC_GLITCHREPLAY_DSN || DEFAULT_DSN;
const effectiveDsn = DSN_RE.test(rawDsn) ? rawDsn : DEFAULT_DSN;
const parts = effectiveDsn.match(DSN_RE)!;

/** Full Sentry-style DSN this deployment reports into. */
export const GLITCHREPLAY_DSN = effectiveDsn;
/** Public ingest key (the part before `@` — safe to ship client-side). */
export const GLITCHREPLAY_PUBLIC_KEY = parts[1];
/** Ingest host, e.g. `glitchreplay.com`. */
export const GLITCHREPLAY_HOST = parts[2];
/** Project id, e.g. `prj_…`. */
export const GLITCHREPLAY_PROJECT_ID = parts[3];
